// API Configuration
// Automatically detects the correct API URL based on environment

const getApiUrl = (): string => {
  // Use environment variable if set (for flexible deployment)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // In production, frontend is on blob storage — must use absolute backend URL
  if (process.env.NODE_ENV === 'production') {
    return 'https://shahosuite-c0hjh2f7gkh2azbn.uksouth-01.azurewebsites.net/api';
  }

  // In development, use local backend
  return 'http://localhost:5000/api';
};

const API_URL = getApiUrl();

export default API_URL;
